import { AbstractControl, ValidationErrors } from '@angular/forms';

export class DirectDebitValidators {
  static accountOwner(control: AbstractControl): ValidationErrors | null {
    const value: string | null = control.value;

    if (value === null) {
      return null;
    } else if (value.replace(/[^a-zA-Z]/g, '').length < 1) {
      return { accountOwner: true };
    } else if (value.replace(/[^a-zA-Z0-9]/g, '').length < 3) {
      return { accountOwner: true };
    } else {
      return null;
    }
  }

  static iban(control: AbstractControl): ValidationErrors | null {
    const value: string | null = control.value;
    if (value === null) {
      return null;
    } else if (DirectDebitValidators.isValidIBAN(value)) {
      return null;
    } else {
      return { iban: true };
    }
  }

  private static isValidIBAN(input: string): boolean {
    const iban = input.toUpperCase().replace(/[^A-Z0-9]/g, '');
    const validators = iban.substring(0, 4);
    const rearrangedIban = iban.slice(4) + validators;
    const code = rearrangedIban.replace(/[A-Z]/g, match => `${match.charCodeAt(0) - 55}`);
    return DirectDebitValidators.moduloCalc(code) === 1;
  }

  private static moduloCalc(code: string): number {
    let temp = '';
    let r = '';
    for (let i = 0; i < code.length; ) {
      const start = i;
      if (i === 0) {
        i = 9;
      } else if (i + 7 > code.length) {
        i = code.length;
      } else {
        i = i + 7;
      }
      temp = r + code.substring(start, i);
      r = `${parseInt(temp, 10) % 97}`;
    }
    return parseInt(r, 10);
  }
}
